import { StyleSheet } from "@react-pdf/renderer";

const DARK = "#1D2939";
const AMBER = "#FFAF4A";
const GRAY = "#6B7280";
const LIGHT = "#F9FAFB";
const BORDER = "#E5E7EB";

export const styles = StyleSheet.create({
  // ─── COVER PAGE ───
  coverPage: {
    backgroundColor: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: 9,
  },
  coverHeader: {
    backgroundColor: DARK,
    padding: "24px 32px 20px 32px",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  coverLogo: {
    flexDirection: "row",
    alignItems: "center",
  },
  coverLogoIcon: {
    width: 32,
    height: 32,
    marginRight: 8,
    borderRadius: 6,
  },
  coverLogoFallback: {
    width: 32,
    height: 32,
    borderRadius: 6,
    backgroundColor: AMBER,
    justifyContent: "center",
    alignItems: "center",
    marginRight: 8,
  },
  coverLogoFallbackText: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#000",
  },
  coverLogoText: {
    fontSize: 14,
    color: "#FFFFFF",
    fontWeight: "bold",
  },
  coverLogoSub: {
    fontSize: 7,
    color: "#94A3B8",
  },
  coverGenerated: {
    fontSize: 7,
    color: AMBER,
    textAlign: "right",
  },
  coverGeneratedDate: {
    fontSize: 7,
    color: "#94A3B8",
    textAlign: "right",
  },

  // ─── HERO ───
  coverHero: {
    backgroundColor: DARK,
    paddingHorizontal: 32,
    paddingBottom: 24,
  },
  coverBadgeRow: {
    flexDirection: "row",
    marginBottom: 10,
    gap: 6,
  },
  coverBadge: {
    backgroundColor: AMBER,
    borderRadius: 4,
    padding: "4px 10px",
    fontSize: 8,
    fontWeight: "bold",
    color: "#000",
  },
  coverBadgeAlt: {
    backgroundColor: "#10B981",
    borderRadius: 4,
    padding: "4px 10px",
    fontSize: 8,
    fontWeight: "bold",
    color: "#FFF",
  },
  coverClientName: {
    fontSize: 26,
    fontWeight: "bold",
    color: "#FFFFFF",
    marginBottom: 4,
  },
  coverSubtitle: {
    fontSize: 10,
    color: "#94A3B8",
  },

  // ─── INFO SECTION ───
  infoSection: {
    padding: "16px 32px",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  infoColumn: {
    width: "48%",
  },
  infoTitle: {
    fontSize: 8,
    fontWeight: "bold",
    color: GRAY,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    marginBottom: 8,
    borderBottomWidth: 0.5,
    borderBottomColor: BORDER,
    paddingBottom: 4,
  },
  infoRow: {
    flexDirection: "row",
    marginBottom: 5,
  },
  infoLabel: {
    fontSize: 8,
    color: GRAY,
    width: 90,
  },
  infoValue: {
    fontSize: 8,
    color: "#111827",
    fontWeight: "bold",
    flex: 1,
  },

  // ─── CONTRIBUTING STAFF ───
  staffSection: {
    padding: "12px 32px",
    borderTopWidth: 0.5,
    borderTopColor: BORDER,
  },
  staffTitle: {
    fontSize: 8,
    fontWeight: "bold",
    color: GRAY,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    marginBottom: 8,
  },
  staffRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },
  staffCard: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#F3F4F6",
    borderRadius: 6,
    padding: "6px 12px",
    width: "48%",
  },
  staffAvatar: {
    width: 28,
    height: 28,
    borderRadius: 14,
    backgroundColor: AMBER,
    justifyContent: "center",
    alignItems: "center",
    marginRight: 8,
  },
  staffInitials: {
    fontSize: 10,
    fontWeight: "bold",
    color: "#000",
  },
  staffName: {
    fontSize: 9,
    fontWeight: "bold",
    color: "#111827",
  },
  staffRole: {
    fontSize: 7,
    color: GRAY,
  },

  // ─── ADL MATRIX SNAPSHOT ───
  adlSection: {
    padding: "12px 32px",
    borderTopWidth: 0.5,
    borderTopColor: BORDER,
  },
  adlTitle: {
    fontSize: 8,
    fontWeight: "bold",
    color: GRAY,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    marginBottom: 4,
  },
  adlSubtitle: {
    fontSize: 7,
    color: GRAY,
    marginBottom: 8,
  },
  adlCardsRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 6,
  },
  adlCard: {
    width: "31%",
    backgroundColor: "#F9FAFB",
    border: "0.5px solid #E5E7EB",
    borderRadius: 6,
    padding: "8px 10px",
    marginBottom: 4,
  },
  adlCardActivity: {
    fontSize: 8,
    color: GRAY,
    marginBottom: 4,
  },
  adlCodeRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  adlCodeBadge: {
    width: 18,
    height: 18,
    borderRadius: 4,
    justifyContent: "center",
    alignItems: "center",
  },
  adlCodeText: {
    fontSize: 9,
    fontWeight: "bold",
    color: "#FFF",
  },
  adlCodeLabel: {
    fontSize: 8,
    color: "#111827",
  },
  adlCardNote: {
    fontSize: 7,
    color: GRAY,
    fontStyle: "italic",
    marginTop: 2,
  },
  adlLegend: {
    flexDirection: "row",
    gap: 10,
    marginTop: 8,
    alignItems: "center",
  },
  adlLegendItem: {
    flexDirection: "row",
    alignItems: "center",
    gap: 3,
  },
  adlLegendDot: {
    width: 12,
    height: 12,
    borderRadius: 3,
    justifyContent: "center",
    alignItems: "center",
  },
  adlLegendText: {
    fontSize: 7,
    color: GRAY,
  },

  // ─── FOOTER ───
  coverFooter: {
    position: "absolute",
    bottom: 20,
    left: 32,
    right: 32,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
    borderTopWidth: 0.5,
    borderTopColor: BORDER,
    paddingTop: 8,
  },
  footerLeft: {},
  footerBrand: {
    fontSize: 8,
    color: "#111827",
    fontWeight: "bold",
  },
  footerFacility: {
    fontSize: 7,
    color: GRAY,
  },
  footerConfidential: {
    fontSize: 7,
    color: GRAY,
  },
  footerRight: {
    textAlign: "right",
  },
  footerPage: {
    fontSize: 8,
    color: "#111827",
  },
  footerContinues: {
    fontSize: 7,
    color: GRAY,
  },

  // ─── CHECKLIST PAGES ───
  checklistPage: {
    backgroundColor: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: 9,
    padding: "20px 24px",
  },
  checklistHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 12,
    borderBottomWidth: 0.5,
    borderBottomColor: BORDER,
    paddingBottom: 8,
  },
  checklistHeaderLeft: {
    flexDirection: "row",
    alignItems: "center",
  },
  checklistLogo: {
    width: 24,
    height: 24,
    marginRight: 8,
  },
  checklistFacilityName: {
    fontSize: 10,
    fontWeight: "bold",
    color: "#111827",
  },
  checklistFacilitySub: {
    fontSize: 7,
    color: GRAY,
  },
  checklistHeaderRight: {
    textAlign: "right",
  },
  checklistClientName: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#111827",
  },
  checklistDateRange: {
    fontSize: 8,
    color: GRAY,
  },
  checklistSectionTitle: {
    fontSize: 9,
    fontWeight: "bold",
    color: GRAY,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    marginBottom: 6,
  },

  // ─── TASK ENTRY CARD ───
  taskCard: {
    border: "0.5px solid #D1D5DB",
    borderRadius: 4,
    marginBottom: 10,
    overflow: "hidden",
  },
  taskCardHeader: {
    backgroundColor: DARK,
    padding: "6px 10px",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  taskCardClientName: {
    fontSize: 10,
    fontWeight: "bold",
    color: "#FFFFFF",
  },
  taskCardDate: {
    fontSize: 9,
    color: "#D1D5DB",
  },
  taskCardBody: {
    flexDirection: "row",
    flexWrap: "wrap",
    padding: "6px 8px",
  },
  taskCategory: {
    width: "33%",
    padding: "4px 4px",
    marginBottom: 2,
  },
  taskCategoryTitle: {
    fontSize: 8,
    fontWeight: "bold",
    color: "#111827",
    textTransform: "uppercase",
    marginBottom: 4,
    borderBottomWidth: 0.5,
    borderBottomColor: BORDER,
    paddingBottom: 2,
  },
  taskCheckRow: {
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: 3,
    gap: 4,
    
  },
  taskCheckbox: {
    width: 10,
    height: 10,
    border: "0.8px solid #D0D5DD",
    borderRadius: 2,
    marginRight: 4,
    marginTop: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  taskChecked: {
    backgroundColor: "#374151",
    borderColor: "#374151",
  },
  taskCheckmark: {
    width: 6,
  },
  taskFieldName: {
    fontSize: 8,
    color: "#374151",
    flex: 1,
  },
  taskFieldValue: {
    fontSize: 7,
    color: "#6B7280",
    backgroundColor: "#F3F4F6",
    borderRadius: 3,
    padding: "2px 4px",
    marginLeft: 14,
    marginBottom: 2,
  },
  taskCommentsSection: {
    borderTopWidth: 0.5,
    borderTopColor: BORDER,
    padding: "4px 10px",
    backgroundColor: "#F9FAFB",
  },
  taskCommentsTitle: {
    fontSize: 8,
    fontWeight: "bold",
    color: GRAY,
    textTransform: "uppercase",
    marginBottom: 3,
  },
  taskCommentAuthor: {
    fontSize: 7,
    color: "#111827",
    fontWeight: "bold",
  },
  taskCommentText: {
    fontSize: 8,
    color: "#374151",
    fontStyle: "italic",
    marginBottom: 4,
  },
  taskCarePlanSection: {
    borderTopWidth: 0.5,
    borderTopColor: BORDER,
    padding: "4px 10px",
    backgroundColor: "#F9FAFB",
  },
  taskCarePlanTitle: {
    fontSize: 8,
    fontWeight: "bold",
    color: GRAY,
    textTransform: "uppercase",
    marginBottom: 3,
  },
  taskCarePlanLabel: {
    fontSize: 8,
    color: "#374151",
    marginBottom: 1,
  },
  taskCarePlanMeta: {
    fontSize: 7,
    color: GRAY,
    marginBottom: 4,
  },
  taskFooter: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "4px 10px",
    borderTopWidth: 0.5,
    borderTopColor: BORDER,
  },
  taskShiftLabel: {
    fontSize: 8,
    color: AMBER,
    fontWeight: "bold",
  },
  taskStaffRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  taskStaffLabel: {
    fontSize: 8,
    fontWeight: "bold",
    color: "#111827",
  },
  taskStaffName: {
    fontSize: 8,
    color: "#374151",
  },
  taskSignature: {
    width: 60,
    height: 25,
    backgroundColor: "#F3F4F6",
    borderRadius: 4,
    justifyContent: "center",
    alignItems: "center",
    marginLeft: 4,
  },
  taskSigText: {
    fontSize: 14,
    fontFamily: "Island Moments",
    color: "#000",
  },

  // ─── PAGE FOOTER ───
  pageFooter: {
    position: "absolute",
    bottom: 12,
    left: 24,
    right: 24,
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: 7,
    color: GRAY,
  },
});
